/**
 * Selects the text contents of either input/textarea or contenteditable.
 */
export function selectElementContents(el: HTMLElement) {
  var range = document.createRange();
  range.selectNodeContents(el);
  var sel = window.getSelection();

  if(sel) {
    sel.removeAllRanges();
    sel.addRange(range);
  } else {
    console.warn('Could not select text in element (no returned selection form window.getSelection)', el);
  }
}


export function getImageSize(url: string): Promise<{width: number, height: number, aspectRatio: number}> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({width: img.width, height: img.height, aspectRatio: img.width / img.height});
    };
    img.onerror = (err) => {
      reject(err);
    };
    img.src = url;
  });
}

export function isElemOverflown(element: HTMLElement) {
  element.scrollTo(0, 0);
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
